(function () {
  if (window.__bfCampaignAnchorInitialized) {
    return;
  }
  window.__bfCampaignAnchorInitialized = true;

  var HASH = 'black-friday';
  var MENU_LABELS = ['black friday', 'black friday promo', 'bf promo'];

  function normalizePath(path) {
    if (!path || path === '/') return '/';
    var p = path.split('?')[0].replace(/\/+$/, '');
    return p || '/';
  }

  function isHomePath(path) {
    var p = normalizePath(path);
    if (p === '/' || p === '/index') return true;
    if (/\/pages\/home$/i.test(p)) return true;
    return false;
  }

  function headerOffset() {
    var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var px = parseFloat(raw);
    return (Number.isFinite(px) ? px : 80) + 16;
  }

  function findAnchor() {
    var active = document.querySelector('[data-bf-campaign-anchor][data-campaign-active="true"]');
    if (active) return active;
    return document.querySelector('[data-bf-campaign-anchor]');
  }

  function scrollTargetForAnchor(el) {
    if (!el) return null;
    return el.closest('.shopify-section') || el;
  }

  function scrollToCampaignAnchor(behavior) {
    var el = findAnchor();
    if (!el) return false;
    var target = scrollTargetForAnchor(el);
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'smooth' });
    return true;
  }

  function hashMatches() {
    var hash = (window.location.hash || '').replace(/^#/, '').toLowerCase();
    return hash === HASH;
  }

  function parseLink(href) {
    try {
      return new URL(href, window.location.origin);
    } catch (e) {
      return null;
    }
  }

  function linkHasCampaignHash(href) {
    var url = parseLink(href);
    if (!url) return false;
    return url.hash.replace(/^#/, '').toLowerCase() === HASH;
  }

  function linkTextMatchesMenu(link) {
    if (link.getAttribute('data-bf-campaign-menu') === 'true') return true;
    var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!label) return false;
    for (var i = 0; i < MENU_LABELS.length; i++) {
      if (label === MENU_LABELS[i] || label.indexOf(MENU_LABELS[i]) !== -1) {
        return true;
      }
    }
    return false;
  }

  function linkPointsToHome(href) {
    if (!href || href === '#' || href.charAt(0) === '#') return false;
    var url = parseLink(href);
    if (!url) return false;
    if (url.hash && url.hash.replace(/^#/, '').toLowerCase() !== HASH) {
      return false;
    }
    return isHomePath(url.pathname);
  }

  function goHomeWithHash() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }
    window.location.assign(root + '#' + HASH);
  }

  function onHashNavigate() {
    if (!hashMatches()) return;
    scrollToCampaignAnchor('smooth');
  }

  function handleCampaignMenuClick(event, link, href) {
    if (isHomePath(window.location.pathname)) {
      event.preventDefault();
      if (scrollToCampaignAnchor('smooth')) {
        history.pushState(null, '', '#' + HASH);
      }
      return;
    }
    event.preventDefault();
    goHomeWithHash();
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;

      if (href === '#' + HASH) {
        event.preventDefault();
        if (scrollToCampaignAnchor('smooth')) {
          history.pushState(null, '', '#' + HASH);
        }
        return;
      }

      if (linkHasCampaignHash(href)) {
        var url = parseLink(href);
        if (url && isHomePath(window.location.pathname) && isHomePath(url.pathname)) {
          event.preventDefault();
          if (scrollToCampaignAnchor('smooth')) {
            history.pushState(null, '', '#' + HASH);
          }
        }
        return;
      }

      if (linkTextMatchesMenu(link) && linkPointsToHome(href)) {
        handleCampaignMenuClick(event, link, href);
        return;
      }

      if (linkTextMatchesMenu(link) && (href === '/' || href === '')) {
        handleCampaignMenuClick(event, link, href);
      }
    },
    false
  );

  function boot() {
    if (!hashMatches()) return;

    function run(behavior) {
      scrollToCampaignAnchor(behavior);
    }

    run('auto');
    window.requestAnimationFrame(function () {
      run('auto');
      window.setTimeout(function () {
        run('auto');
      }, 450);
      window.setTimeout(function () {
        run('auto');
      }, 1200);
    });
  }

  window.addEventListener('hashchange', onHashNavigate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    if (hashMatches()) {
      scrollToCampaignAnchor('auto');
    }
  });

  document.addEventListener('shopify:section:load', function () {
    if (hashMatches()) {
      scrollToCampaignAnchor('auto');
    }
  });
})();
